<template>
  <div class="m-no-markets">
    There are no markets currently
  </div>
</template>

<script>
export default {
  name: 'NoMarkets'
}
</script>

<style lang="less">
@import url("~wap/common/style/variable.less");

.m-no-markets {
  padding: 82/@rem 0;
  color: #999;
  font-size: 14/@rem;
  line-height: 18/@rem;
  text-align: center;
}
</style>
